export const toPathIsh = (val?: string): string =>
  encodeURIComponent(val ? val.replace(/\s+/g, "-") : "");
